module.exports = __webpack_public_path__ + "img/bg.65eb3506.jpg";